import React from 'react'
import _ from 'lodash'
import Griddle from 'griddle-react'
import { Link } from 'react-router'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import { getToken } from '../../Commons/Authentication'
import NavigationBar from '../../Commons/NavigationBar'
import { ToastContainer, ToastMessage } from 'react-toastr'
import SearchImage from '../../../img/icons/general-icons/search_icon.png'
import LinkUpdateGroup from './LinkUpdateGroup'
import NotDataAvailable from './NotDataAvailable'
import EditIcon from '../../../img/icons/general-icons/icon_edit.png'
import GroupIcon from '../../../img/icons/general-icons/add_user_icon.png'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

export default class SearchGroup extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({ groupList: [], showTable: true })
    this.listGroup()
  }

  listGroup () {
    request
    .get('api/v1/group/')
    .set('Authorization', 'Bearer ' + getToken())
    .use(NoCache)
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (res.statusCode === 200) {
        this.setState({ groupList: res.body })
      } else {
        if (err) {
          this.refs.container.error('Algo inesperado ocurrió, no se encontraron Grupos', '', {
            closeButton: true
          })
        }
      }
    })
  }

  showGroupTable () {
    this.setState({ showTable: true })
  }

  findGroupAhead () {
    let val = this.refs.query.value
    let url = `api/v1/group/typeahead?nombre=${val}`
    request
    .get(url)
    .set('Authorization', 'Bearer ' + getToken())
    .use(NoCache)
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (res.statusCode === 200) {
        this.setState({ groupList: res.body })
        this.showGroupTable()
      } else {
        if (err) {
          this.refs.container.error('No se encontro información de grupos', '', {
            closeButton: true
          })
        }
      }
    })
  }

  render () {
    document.title = 'Listado de Grupos - CORE 3.0'
    var information = this.state.groupList
    var groupData = []
    var columnsData = [
      {
        'columnName': 'Nombre'
      },
      {
        'columnName': 'Estado'
      },
      {
        'columnName': ' ',
        'customComponent': LinkUpdateGroup
      }
    ]
    _.forEach(information, (key, vals) => {
      groupData.push({
        'Nombre': key.nombre,
        'Estado': key.status ? 'activo' : 'inactivo',
        ' ': EditIcon
      })
    })
    return (
      <div className='form-page-container before-griddle'>
        <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
        <NavigationBar />
        <div className='form-field-container'>
          <img className='form-field-image' src={SearchImage}/>
          <input id='searchGroup' ref='query' className='form-input-search' onChange={(e) => { this.findGroupAhead() }} group='text' placeholder='Buscar Grupo....' />
        </div>
        <div className='table-container'>
          <Griddle tableClassName='table' showFilter={false} showSettings={false} customNoDataComponent={NotDataAvailable} columnMetadata={columnsData} results={groupData} resultsPerPage={10} enableInfiniteScroll={true} bodyHeight={350}/>
        </div>
        <div className='form-field-new-group'>
          <img className='form-field-image' src={GroupIcon} />
          <Link className='form-link-new-group' to={'/group'}>Ingresar nuevo Grupo</Link>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Group/SearchGroup/SearchComponent.js